/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  rotate?: number,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ArrowDownIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 10 10"
    onClick={props.onClick}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ transform: `rotate(${typeof props.rotate === "number" ? props.rotate : 0}deg)` }}
  >
    <g>
      <path d="M5.00757576,9.35757576 L5.00757576,0.645454545" />
      <polyline points="0.840909091 4.62272727 5.00757576 9.35757576 9.17424242 4.62272727" />
    </g>
  </svg>
);

export default ArrowDownIcon;
